var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({attrs:{"min":_vm.min,"max":_vm.max,"interval":_vm.interval,"value":_vm.value},on:{"callback":_vm.update,"drag-start":_vm.dragStart,"drag-end":_vm.dragEnd}},'vue-slider',_vm.options,false))}
var staticRenderFns = []

export { render, staticRenderFns }